namespace $.$$ {

	export class $shm_hitalama_map_command_palette extends $.$shm_hitalama_map_command_palette {

		collector_run = ''

		commands_map() {
			return this.$.$shm_hitalama_profile.current()?.templates_commands() ?? null
		}

		js_templates_map() {
			return this.$.$shm_hitalama_profile.current()?.templates_js() ?? null
		}

		commands(): readonly $shm_hitalama_map_widget[] {
			return this.commands_map()?.Widgets_list(null)?.remote_list().filter( ( widget: $shm_hitalama_map_widget ) => {
				return widget.type() === 'code_js'
			} ) ?? []
		}

		js_templates(): readonly $shm_hitalama_map_widget[] {
			return this.js_templates_map()?.Widgets_list(null)?.remote_list().filter( ( widget: $shm_hitalama_map_widget ) => {
				return widget.type() === 'code_js'
			} ) ?? []
		}

		command_item( widget: $shm_hitalama_map_widget ): $shm_hitalama_command_palette_item {
			return {
				id: 'command:' + widget.link_str(),
				title: widget.title(),
			}
		}

		js_template_item( widget: $shm_hitalama_map_widget ): $shm_hitalama_command_palette_item {
			return {
				id: 'js_template:' + widget.link_str(),
				title: `JS виджет: ${ widget.title() }`,
			}
		}

		current_map() {
			const id = this.$.$shm_hitalama_app.Root(0).map_id()
			if( !id ) return null
			return this.$.$shm_hitalama_app.Root(0).map()
		}

		benchmark_journal() {
			return this.current_map()?.journal_snapshots() ?? null
		}

		benchmark_item(): $shm_hitalama_command_palette_item | null {
			const journal = this.benchmark_journal()
			if( !journal ) return null
			const active = journal.write_started() && !journal.write_stopped()
			return active
				? { id: 'benchmark:stop', title: 'Завершить бенчмарк' }
				: { id: 'benchmark:start', title: 'Начать бенчмарк' }
		}

		items(): readonly $shm_hitalama_command_palette_item[] {
			const benchmark = this.benchmark_item()
			return [
				... ( benchmark ? [ benchmark ] : [] ),
				... this.commands().map( command => this.command_item( command ) ),
				... this.js_templates().map( template => this.js_template_item( template ) ),
			]
		}

		command_by_id( id: string ) {
			return this.commands().find( command => 'command:' + command.link_str() === id ) ?? null
		}

		js_template_by_id( id: string ) {
			return this.js_templates().find( template => 'js_template:' + template.link_str() === id ) ?? null
		}

		command_contexts = new WeakMap< $shm_hitalama_map_widget, Record< string, $shm_hitalama_map_widget > >

		command_context( command: $shm_hitalama_map_widget ) {
			let context = this.command_contexts.get( command )
			if( context ) return context

			context = { [ '$' + 'this_widget' ]: command }
			this.command_contexts.set( command, context )
			return context
		}

		@ $mol_action
		item_submit( id: string, event?: Event ) {
			if( id === 'benchmark:start' ) {
				this.benchmark_start()
				return null
			}

			if( id === 'benchmark:stop' ) {
				this.benchmark_stop()
				return null
			}

			const command = this.command_by_id( id )
			if( command ) {
				command.map().execute_action( command.code(), this.command_context( command ) )
				return command
			}

			const template = this.js_template_by_id( id )
			if( template ) {
				return this.js_template_create( template )
			}

			return null
		}

		@ $mol_action
		benchmark_start() {
			const journal = this.benchmark_journal()
			if( !journal ) return
			const map = this.current_map()
			if( map ) $shm_hitalama_map_journal_recorder.clear( map )
			journal.write_start()
			this.collector_run = ''
		}

		@ $mol_action
		benchmark_stop() {
			const journal = this.benchmark_journal()
			if( !journal ) return
			journal.write_stop()
			this.collector_run = journal.run_id()
		}

		@ $mol_mem
		benchmark_collect_notification() {
			const run = this.collector_run
			if( !run ) return null

			const journal = this.benchmark_journal()
			const map = this.current_map()
			if( !journal || !map ) return null
			if( journal.run_id() !== run ) return null

			const clients = journal.clients().length
			const written = journal.snapshots_written_count()
			$shm_hitalama_map_journal_analysis_widgets.ensure_if_ready( map, journal )
			if( written >= clients && clients > 0 ) this.collector_run = ''

			return null
		}

		@ $mol_action
		js_template_create( template: $shm_hitalama_map_widget ) {
			const map = $shm_hitalama_app.Root(0).map()
			const center = $shm_hitalama_app.Root(0).Map().Map_page().get_center_pos() ?? [0, 0]
			const width = template.right_edge_x() || 600
			const height = template.bottom_edge_y() || 300
			const widget = map.widget_add(
				'code_js',
				[ center[0] - width / 2, center[1] - height / 2 ],
				width,
				height,
			)

			widget?.title( template.title() )
			widget?.code( template.code() )
			widget?.enabled( template.enabled() )
			return widget
		}

	}

}
